export namespace IndividualExplanationParams {
    /**
     * Generated from com.dataiku.dip.analysis.ml.prediction.flow.IndividualExplanationParams$ExplanationsMethod
     */
    export enum ExplanationsMethod {
        ICE = 'ICE',
        SHAPLEY = 'SHAPLEY'
    }
}